
<h1 fxLayout="column" fxLayoutAlign="center center">Crear Muestra:</h1>

<div fxLayout="column" fxLayoutAlign="start center" >
<div class="" fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" fxFlex="100" class="pl-4">
        <mat-label>{{'RESULTA-AUDITO.INGRE-NOM' | translate}}</mat-label>
        <input matInput [(ngModel)]="nombre">
        <mat-icon matSuffix class="secondary-text">assignment</mat-icon>
    </mat-form-field>

</div>

    <mat-form-field  style="width:100%" appearance="outline" fxFlex="100">
        <mat-label>{{'RESULTA-AUDITO.SELEC-REG' | translate}}</mat-label>
        <mat-select required multiple [(value)]="selected">
            <mat-option *ngFor="let reglas of reglas" [value]="reglas.id">
              {{'RESULTA-AUDITO.REGLAS.'+reglas.id | translate}}
            </mat-option>
        </mat-select>
        <mat-icon matSuffix class="secondary-text">list</mat-icon>
    </mat-form-field>
</div>



    <button mat-raised-button style="width:100%" color="accent" (click)="guardaMuestra(nombre,selected)" >{{'PERFILES.USUARIO.GUARDA' | translate}}</button>
